import { render, staticRenderFns } from "./StudioProductLessons.vue?vue&type=template&id=729a4d39&scoped=true&"
import script from "./StudioProductLessons.vue?vue&type=script&lang=js&"
export * from "./StudioProductLessons.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductLessons.vue?vue&type=style&index=0&id=729a4d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729a4d39",
  null
  
)

export default component.exports